<template>
  <el-dialog 
    :title="$t('dictManage.addDict')" 
    :visible.sync="dialogVisible"
    width="50%"
  >
    <el-form 
      ref="form" 
      :model="addDictInfo" 
      label-width="100px"
      :rules="rules"
    >
      <el-form-item 
        :label="$t('dictManage.type')" 
        prop="specId"
      >
        <el-select 
          v-model="addDictInfo.specId" 
          :placeholder="$t('dictManage.selectType')"
          style="width:100%"
        >
          <el-option 
            v-for="item in addDictInfo.dictSpecs"
            :key="item.specId"
            :label="item.specName"
            :value="item.specId"
          />
        </el-select>
      </el-form-item>
      <el-form-item 
        :label="$t('dictManage.name')" 
        prop="name"
      >
        <el-input 
          v-model="addDictInfo.name" 
          :placeholder="$t('dictManage.inputNameRequired')"
        />
      </el-form-item>
      <el-form-item 
        :label="$t('dictManage.value')" 
        prop="statusCd"
      >
        <el-input 
          v-model="addDictInfo.statusCd" 
          :placeholder="$t('dictManage.inputValueRequired')"
        />
      </el-form-item>
      <el-form-item 
        :label="$t('dictManage.description')" 
        prop="description"
      >
        <el-input 
          v-model="addDictInfo.description" 
          :placeholder="$t('dictManage.inputDescRequired')"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('dictManage.cancel') }}
      </el-button>
      <el-button 
        type="primary" 
        @click="saveDictInfo"
      >
        {{ $t('dictManage.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveDict } from '@/api/dev/dictApi'
import { listDictSpec } from '@/api/dev/dictApi'

export default {
  name: 'AddDict',
  data() {
    return {
      dialogVisible: false,
      addDictInfo: {
        specId: '',
        name: '',
        statusCd: '',
        description: '',
        dictSpecs: []
      },
      rules: {
        specId: [
          { required: true, message: this.$t('dictManage.typeRequired'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('dictManage.nameRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('dictManage.nameMaxLength'), trigger: 'blur' }
        ],
        statusCd: [
          { required: true, message: this.$t('dictManage.valueRequired'), trigger: 'blur' },
          { max: 64, message: this.$t('dictManage.valueMaxLength'), trigger: 'blur' }
        ],
        description: [
          { required: true, message: this.$t('dictManage.descRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('dictManage.descMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this._listDictSpecs()
      })
    },
    async _listDictSpecs() {
      try {
        const res = await listDictSpec({ page: 1, row: 1000 })
        this.addDictInfo.dictSpecs = res.data
      } catch (error) {
        console.error('获取字典类型失败:', error)
      }
    },
    async saveDictInfo() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        
        try {
          await saveDict(this.addDictInfo)
          this.$message.success(this.$t('dictManage.addSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error('添加字典失败:', error)
        }
      })
    }
  }
}
</script>